import { type VariantProps, cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../utils'

export const baseInputStyles = [
  'text-lg text-input-foreground',
  'flex h-13 w-full rounded-md px-3 py-1',

  // Disabled state
  'disabled:cursor-not-allowed disabled:hover:bg-input-secondary-background disabled:opacity-50',

  // Hover state
  'hover:bg-input-background hover:border-input-background',

  'file:border-0 file:bg-transparent file:text-sm file:font-medium',
].join(' ')

const defaultInputStyle = [
  'bg-input-secondary-background border border-input-secondary-border outline-0 outline-input-focus-shadow',

  // Error state
  'aria-invalid:drop-shadow-(--input-invalid-shadow) aria-invalid:border-input-invalid aria-invalid:border',
  // Focus
  'focus-visible:ring focus-visible:ring-input-focus-border focus-visible:bg-input-background focus-visible:outline-3 focus-visible:outline-offset-1',
].join(' ')
//
export const inputStyles = `${baseInputStyles} ${defaultInputStyle}`

export const inputVariants = cva(baseInputStyles, {
  variants: {
    size: {
      default: '',
      lg: 'text-2xl py-4 h-auto',
    },
    variant: {
      default: defaultInputStyle,
      ghost: 'bg-transparent border-0 focus-visible:outline-hidden',
    },
  },

  defaultVariants: {
    size: 'default',
    variant: 'default',
  },
})

export type InputProps = Omit<React.ComponentPropsWithoutRef<'input'>, 'size'> &
  VariantProps<typeof inputVariants>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          inputVariants({ size, variant }),
          {
            'bg-input-background border-input-background':
              !!props.value && variant !== 'ghost',
          },
          className,
        )}
        ref={ref}
        {...props}
        value={props.value ?? ''}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
